export const disputeSection = '/disputes';

export const disputePath = disputeSection;
export const disputeCreatePath = disputeSection + '/create';
export const disputeCreateRoute = disputeCreatePath;
export const disputeDetailPath = (id: string) => `${disputeSection}/dispute-detail/${id}`;
export const disputeDetailRoute = disputeSection + '/dispute-detail/:disputeId';
export const disputeAcceptPath = disputeSection + '/dispute-accept';
export const disputeDeclinePath = (id?: string) =>
  id ? `${disputeSection}/dispute-decline/${id}` : `${disputeSection}/dispute-decline`;
export const disputeDeclineRoute = disputeSection + '/dispute-decline/:disputeId?';